import React, { useEffect, useState } from "react";
import { CheckCircleFilled } from "@ant-design/icons";
import "./SuccessAnimation.less";

const SuccessAnimation = ({ count, label = "patients notified" }) => {
  const [showCheck, setShowCheck] = useState(false);
  const [showCount, setShowCount] = useState(false);

  useEffect(() => {
    // Stagger the animations
    const checkTimer = setTimeout(() => setShowCheck(true), 100);
    const countTimer = setTimeout(() => setShowCount(true), 400);

    return () => {
      clearTimeout(checkTimer);
      clearTimeout(countTimer);
    };
  }, []);

  return (
    <div className="success-animation-container">
      {/* Success content */}
      <div className="success-content">
        <div className={`success-check ${showCheck ? "visible" : ""}`}>
          <CheckCircleFilled />
        </div>
        <div className={`success-text ${showCount ? "visible" : ""}`}>
          <span className="success-count">{count}</span>
          <span className="success-label">{label}</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessAnimation;
